import { Link } from "react-router-dom";

/**
 *
 */
function MasterManagement() {
  return (
    <main className="container">
      <Link to="/mst-store" style={{ color: "var(--black)" }}>
        <h1>店舗一覧</h1>
      </Link>
      <Link to="/mst-user" style={{ color: "var(--black)" }}>
        <h1>利用者一覧</h1>
      </Link>
      <Link to="/mst-client" style={{ color: "var(--black)" }}>
        <h1>得意先一覧</h1>
      </Link>
    </main>
  );
}

export default MasterManagement;
